import { render } from "./Discography.vue?vue&type=template&id=c1a44e0e"
import script from "./Discography.vue?vue&type=script&lang=js"
export * from "./Discography.vue?vue&type=script&lang=js"

import "./Discography.vue?vue&type=style&index=0&id=c1a44e0e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__